export function AddAttachment(organizationID: number, postID: number, attachmentID: number): string {
	return `/v1/organizations/${organizationID}/group-posts/${postID}/attachments/${attachmentID}`;
}

export function AddComment(organizationID: number, postID: number): string {
	return `/v1/organizations/${organizationID}/group-posts/${postID}/comments`;
}

export function AddLike(organizationID: number, postID: number): string {
	return `/v1/organizations/${organizationID}/group-posts/${postID}/likes`;
}

export function AddView(organizationID: number, postID: number): string {
	return `/v1/organizations/${organizationID}/group-posts/${postID}/views`;
}

export function Create(organizationID: number, groupID: number): string {
	return `/v1/organizations/${organizationID}/groups/${groupID}/posts`;
}

export function Delete(organizationID: number, postID: number): string {
	return `/v1/organizations/${organizationID}/group-posts/${postID}`;
}

export function DeleteComment(organizationID: number, commentID: number): string {
	return `/v1/organizations/${organizationID}/group-post-comments/${commentID}`;
}

export function Index(organizationID: number, groupID: number): string {
	return `/v1/organizations/${organizationID}/groups/${groupID}/posts`;
}

export function ListCopies(organizationID: number, postID: number): string {
	return `/v1/organizations/${organizationID}/group-posts/${postID}/copies`;
}

export function OfferedReactions(organizationID: number, groupID: number): string {
	return `/v1/organizations/${organizationID}/groups/${groupID}/post-reactions`;
}

export function RemoveAttachment(organizationID: number, postID: number, attachmentID: number): string {
	return `/v1/organizations/${organizationID}/group-posts/${postID}/attachments/${attachmentID}`;
}

export function RemoveCommentReaction(organizationID: number, commentID: number): string {
	return `/v1/organizations/${organizationID}/group-post-comments/${commentID}/reaction`;
}

export function RemoveLike(organizationID: number, postID: number): string {
	return `/v1/organizations/${organizationID}/group-posts/${postID}/likes`;
}

export function RemoveReaction(organizationID: number, postID: number): string {
	return `/v1/organizations/${organizationID}/group-posts/${postID}/reaction`;
}

export function SetCommentReaction(organizationID: number, commentID: number): string {
	return `/v1/organizations/${organizationID}/group-post-comments/${commentID}/reaction`;
}

export function SetReaction(organizationID: number, postID: number): string {
	return `/v1/organizations/${organizationID}/group-posts/${postID}/reaction`;
}

export function Show(organizationID: number, postID: number): string {
	return `/v1/organizations/${organizationID}/group-posts/${postID}`;
}

export function ShowCommentReactions(organizationID: number, commentID: number): string {
	return `/v1/organizations/${organizationID}/group-post-comments/${commentID}/reactions`;
}

export function ShowComments(organizationID: number, postID: number): string {
	return `/v1/organizations/${organizationID}/group-posts/${postID}/comments`;
}

export function ShowLikes(organizationID: number, postID: number): string {
	return `/v1/organizations/${organizationID}/group-posts/${postID}/likes`;
}

export function ShowReactions(organizationID: number, postID: number): string {
	return `/v1/organizations/${organizationID}/group-posts/${postID}/reactions`;
}

export function ShowViews(organizationID: number, postID: number): string {
	return `/v1/organizations/${organizationID}/group-posts/${postID}/views`;
}

export function Update(organizationID: number, postID: number): string {
	return `/v1/organizations/${organizationID}/group-posts/${postID}`;
}

export function UpdateComment(organizationID: number, commentID: number): string {
	return `/v1/organizations/${organizationID}/group-post-comments/${commentID}`;
}

